import * as React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import DotButton from '../buttons/DotButton';
import { hasValue } from '../../../lib/utils';
import { blueyGrey } from '../../cssConstants';

const RadioQuestion = ({ labelColour, fieldId, value, options, name, label, onValueChange }: Props) => {
	const getOptions = () => {
		if (options && options.length > 0) {
			const copiedOptions = [...options];

			const firstOption = copiedOptions.shift();
			const lastOption = copiedOptions.pop();

			return (
				<>
					<StyledDotButton
						selected={value === firstOption.value}
						key={firstOption.value.toString()}
						className={classNames('leftButton', 'longText')}
						text={firstOption.name}
						value={firstOption.value}
						onClick={() => {
							onValueChange(name, firstOption.value, null);
						}}
					/>
					{copiedOptions.map((option) => {
						return (
							<StyledDotButton
								key={option.value.toString()}
								selected={value === option.value}
								className={classNames('middleButton', 'longText')}
								text={option.name}
								value={option.value}
								onClick={() => {
									onValueChange(name, option.value, null);
								}}
							/>
						);
					})}
					<StyledDotButton
						key={lastOption.value.toString()}
						selected={value === lastOption.value}
						className={classNames('rightButton', 'longText')}
						text={lastOption.name}
						value={lastOption.value}
						onClick={() => {
							onValueChange(name, lastOption.value, null);
						}}
					/>
				</>
			);
		}
		return null;
	};

	return (
		<div className="question" id={fieldId}>
			<Label colour={labelColour}>{label}</Label>
			<div className="buttonCombo">{getOptions()}</div>
		</div>
	);
};

interface Option {
	name: string;
	value: boolean | string | number;
}
interface Props {
	label: string;
	options: Option[];
	value: boolean | string | number;
	name: string;
	onValueChange: (name: string, value: unknown, errorMessage: string) => void;
	labelColour?: string;
	fieldId?: string;
}

RadioQuestion.defaultProps = {
	labelColour: null,
	fieldId: null
};

const Label = styled.label<{ colour: string }>`
	${(props) => (hasValue(props.colour) ? `color: ${props.colour};` : '')}
`;

export default RadioQuestion;

const StyledDotButton = styled(DotButton)`
	border-color: ${blueyGrey};
`;
